import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.71 25a1.49 1.49 0 11-1.48 1.49A1.49 1.49 0 0110.71 25m0-2a3.49 3.49 0 103.48 3.49A3.48 3.48 0 0010.71 23zm13.06 2a1.49 1.49 0 11-1.48 1.49A1.49 1.49 0 0123.77 25m0-2a3.49 3.49 0 103.49 3.49A3.48 3.48 0 0023.77 23zM6.3 6.35L5.43 2H2v2h1.79L6.1 15.55l1.18 5.87h19.93l3-15.07zm2.05 10.21h8v2.86H8.92zm-.2-1l-.68-3.35h8.84v3.35zm9.16-3.35H27l-.67 3.35h-9zm0-1V8.35h10.47l-.57 2.86zm-1-2.86v2.86h-9L6.7 8.35zm1 11.07v-2.86h8.83l-.57 2.86z",
    fill: "#0093d1"
  })));
}

function Cart() {
  return /*#__PURE__*/jsx(SvgCart, {});
}

export { Cart as default };
